import GithubIcon from '@/assets/icons/github.svg?react';
import GoogleIcon from '@/assets/icons/google.svg?react';
import type { OAuthProvider } from '@/shared/config/routes';
import { Button } from '@/shared/ui/button';

type OAuthButtonsProps = { onStart: (provider: OAuthProvider) => void };

export function OAuthButtons({ onStart }: OAuthButtonsProps) {
  return (
    <div data-enter="" className="flex flex-col gap-2.5">
      <Button variant="google" size="lg" isBlock onClick={() => onStart('google')}>
        <GoogleIcon className="size-4.5 shrink-0" />
        Continue with Google
      </Button>
      <Button size="lg" isBlock onClick={() => onStart('github')}>
        <GithubIcon className="size-4.5 shrink-0" />
        Continue with GitHub
      </Button>
    </div>
  );
}
